//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatDate } from '../../../../lib/date';
import fileUploader from '../../../common-components/file-uploader';

export default {
    name: 'delivery-log-list',
    components: { fileUploader },
    props: {
        recordId: {
            required: true,
            type: Number
        }
    },
    filters: {
        formatDate(time, type) {
            const date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            deliveryInfos: [],
            loading: false,
            showChuLiInfoModal: false,
            chuliInfo:{},
            infoTitle:''
        };
    },
    methods: {
        getDeliveryInfoList() {
            this.loading = true;
            abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryInfoList?deliveryRecordId=' + this.recordId).then((resp) => {
                this.deliveryInfos = [];
                this.deliveryInfos.push(...resp.data.result);
            }).finally(() => {
                this.loading = false;
            });
        },
        showChuLi(chuliInfo) {
            this.chuliInfo = chuliInfo;
            this.infoTitle = chuliInfo.operatorTypeStr;
            this.showChuLiInfoModal = true;
        },
    },
    created() {
        this.getDeliveryInfoList();
    }
};
